__webpack_require__.p = "https://suite.mymalls.com/packs/";